// packages/i18n/src/error-keys.ts
//
// Phase 4.12 Task 09 — QUOTE_STALE / SHIPPING_UNAVAILABLE / PRICING_MISMATCH
// error i18n key registry (P4.12.D-16, P4.12.D-17, P4.12.D-22).
//
// vg-binding: CONTEXT:decisions
// vg-binding: INTERFACE-STANDARDS:error-shape
//
// Mirrors the shape of `notifications-keys.ts` but for a SEPARATE error
// catalog: error entries resolve to a single localized STRING (not a
// {title, body} pair) via `lookupError()` in `index.ts`. Do NOT merge this
// registry into `NOTIFICATION_KEYS` / `lookup()` — notification producers
// across the API depend on that catalog's existing {title, body} contract
// (wave-3-context.md "i18n package reality").
export const ERROR_KEYS = {
    // QUOTE_STALE reason-enum keys (P4.12.D-17) — one per fixed reason.
    QUOTE_STALE_PRICE_CHANGED: 'errors.QUOTE_STALE.PRICE_CHANGED',
    QUOTE_STALE_SHIPPING_CHANGED: 'errors.QUOTE_STALE.SHIPPING_CHANGED',
    QUOTE_STALE_TAX_CHANGED: 'errors.QUOTE_STALE.TAX_CHANGED',
    QUOTE_STALE_EXPIRED: 'errors.QUOTE_STALE.EXPIRED',
    QUOTE_STALE_CART_CHANGED: 'errors.QUOTE_STALE.CART_CHANGED',
    QUOTE_STALE_CONSUMED: 'errors.QUOTE_STALE.CONSUMED',
    QUOTE_STALE_MISSING_SNAPSHOT: 'errors.QUOTE_STALE.MISSING_SNAPSHOT',
    // Sibling typed errors owned by the same builder module (P4.12.D-16, D-02).
    SHIPPING_UNAVAILABLE: 'errors.SHIPPING_UNAVAILABLE',
    PRICING_MISMATCH: 'errors.PRICING_MISMATCH',
    RATE_LIMITED: 'errors.RATE_LIMITED',
};
/** Runtime guard — used by lookupError() to reject unknown keys. */
export function isErrorKey(value) {
    return Object.values(ERROR_KEYS).includes(value);
}
/** Flat array form for Zod enum / iteration / catalog-complete assertion. */
export const ERROR_KEY_LIST = Object.values(ERROR_KEYS);
//# sourceMappingURL=error-keys.js.map